<template>
  <div>
    <b-table
      class="bordered mb-1 bar-tab-items-table"
      show-empty
      :empty-text="$t('Nenhum produto consumido')"
      :fields="itemFields"
      :items="getItems"
      :tbody-tr-class="getRowClass"
    >
      <template #cell(name)="row">
        <bar-tab-consumption-item-name :item="row.item" />
      </template>

      <template #cell(price)="row">
        <template v-if="row.item.unitDiscount > 0">
          <span class="item-canceled-price">
            {{ row.item.unitValue | currency }}
          </span>
          <br>
          <span> {{ row.item.price | currency }} </span>
        </template>
        <template v-else>
          {{ row.item.price | currency }}
        </template>
      </template>

      <template #cell(netValue)="{item}">
        <template v-if="item.isKitItem">
          {{ " " }}
        </template>
        <template v-else>
          {{ item.netValue | currency }}
        </template>
      </template>
    </b-table>
  </div>
</template>

<script>
import { BTable } from 'bootstrap-vue'
import { payBoxUtils } from '@/mixins'
import BarTabConsumptionItemName from './BarTabConsumptionItemName.vue'

export default {
  components: {
    BTable,
    BarTabConsumptionItemName,
  },

  props: {
    sale: {
      type: Object,
      required: true,
    },
  },

  computed: {
    itemFields() {
      return [
        {
          label: this.$t('Qtd.'),
          key: 'quantity',
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: { width: '100px' },
        },
        {
          label: this.$t('Nome'),
          key: 'name',
          thClass: 'text-center',
          tdClass: 'text-left',
        },
        {
          label: this.$t('Preço'),
          key: 'price',
          thClass: 'text-center',
          tdClass: 'text-right',
          thStyle: { width: '120px' },
          formatter: value => this.$options.filters.currency(value),
        },
        {
          label: this.$t('Total'),
          key: 'netValue',
          thClass: 'text-center',
          tdClass: 'text-right',
          thStyle: { width: '120px' },
          formatter: value => this.$options.filters.currency(value),
        },
      ]
    },
  },

  methods: {
    getItems() {
      if (!this.sale?.items) return []

      return payBoxUtils.formatBarTabConsumptionItems(this.sale.items, this.sale.itemKits)
    },

    getRowClass(item) {
      return item?.isKit ? 'font-weight-bold' : ''
    },
  },
}
</script>

<style scoped>
.item-canceled-price {
  text-decoration: line-through;
  color: var(--danger);
}

.bar-tab-items-table ::v-deep thead {
  height: 50px;
}

.bar-tab-items-table ::v-deep thead th {
  background-color: var(--theme-color) !important;
  color: var(--white) !important;
}

.bar-tab-items-table ::v-deep tbody > tr:nth-child(2n) > td {
  background-color: rgba(var(--theme-color-rgb), 0.15);
}
</style>
